import netteForms from 'nette-forms';
netteForms.initOnLoad();
import 'plugins/cookie-bar/cookie-bar-naja.js';
// import Swiper from 'swiper';
// import { Navigation } from 'swiper/modules';
// import 'swiper/css';
import simpleLightbox from "simplelightbox/dist/simple-lightbox.jquery";
import slick from "slick-carousel/slick/slick";


// - %appDir%/PublicModule/www/js/jquery/jquery.min.js
// - %appDir%/PublicModule/www/node_modules/slick-carousel/slick/slick.min.js
// - %appDir%/PublicModule/www/js/gallery/simple-lightbox.min.js
// - %appDir%/PublicModule/www/js/nouislider/nouislider.min.js
// - %appDir%/PublicModule/www/js/nouislider/wNumb.min.js
// - %wwwDir%/plugins/nette.ajax/nette.ajax.js
// #                        - %appDir%/PublicModule/www/node_modules/naja/dist/Naja.js
// - %appDir%/PublicModule/www/js/Naja.js
// - %wwwDir%/../vendor/nette/forms/src/assets/netteForms.js
// - %wwwDir%/plugins/cookie-bar/cookie-bar.js
// - %appDir%/PublicModule/www/js/main.js

$(document).ready(function () {
    window.app = new App();
    window.app.init();
});

var App = function () {
};

App.prototype.init = function () {
    var self = this;

    naja.initialize();
    naja.addEventListener('complete', reload.bind(this));
    naja.addEventListener('interaction', interaction.bind(this));

    function reload() {
        window.app.reload();
    }

    function interaction(event) {
        (event.element.hasAttribute("data-confirm")
            && !confirm(event.element.getAttribute("data-confirm")))
            && event.preventDefault();

        if (event.element.hasAttribute("data-scroll-to")) {
            $("html, body").animate({ scrollTop: $(event.element.getAttribute("data-scroll-to")).offset().top }, 300);
        }
    }

    self.reload();
    this.initWebStaff();
    this.initReservationModal();
    this.initCalendar();
    // this.initRecaptcha();
};

App.prototype.initRecaptcha = function () {
    // $('.submit-button-recaptacha').on('click', function (e) {
    //     console.log($(this).closest('form').attr('id'));
    //     var form = document.getElementById($(this).closest('form').attr('id'));
    //     console.log(form);
    //     naja.uiHandler.submitForm(form);
    // });
    // var elements = document.getElementsByClassName("classname");
    //
    // var myFunction = function() {
    //     var attribute = this.getAttribute("data-myattribute");
    //     alert(attribute);
    // };
    //
    // for (var i = 0; i < elements.length; i++) {
    //     elements[i].addEventListener('click', myFunction, false);
    // }


    var clientIDs = {};

    window['g_onRecaptchaLoad'] = function () {
        var currentForm = null;
        var currentEvent = null;

        $('.g-recaptcha').each(function () {
            clientIDs[this.id] = grecaptcha.render(this, {
                size: 'invisible',
                badge: 'inline',
                callback: function (token) {
                    if ($(currentForm).hasClass('ajax')) {
                        $.nette.ajax({}, currentForm, currentEvent);
                    } else {
                        $(currentForm).off('submit.recaptcha').trigger('submit');
                    }
                }

            }, true);
        });

        // $(function () {
        //     $.nette.ext('recaptcha', {
        //         before: function (xhr, settings) {
        //             if (!settings.nette) {
        //                 return true;
        //             }
        //             var analyze = settings.nette;
        //
        //             if (analyze.isSubmit) {
        //                 currentForm = analyze.form;
        //                 currentEvent = analyze.e;
        //
        //                 if ($(currentForm).find('.g-recaptcha').length) {
        //                     $('.g-recaptcha', analyze.form).each(function () {
        //                         grecaptcha.execute(clientIDs[this.id]);
        //                     });
        //
        //                     analyze.e.stopImmediatePropagation();
        //                     analyze.e.preventDefault();
        //                     return false;
        //                 }
        //             }
        //         }
        //     }, {});
        // });

        $('.g-recaptcha').parent().not('ajax').on('submit.recaptcha', function (event) {
            currentForm = this;
            currentEvent = event;

            var form = $(this);
            if (Nette.validateForm(this, true)) {
                // execute only reCAPTCHAs in submitted form
                $('.g-recaptcha', form).each(function () {
                    grecaptcha.execute(clientIDs[this.id]);
                });
            }
        });
    };
}

App.prototype.initCalendar = function () {
    var $calendar = $('#reservationCalendar');
    if (!$calendar.length) return;

    var CZ_MONTHS = [
        'Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen',
        'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'
    ];
    var CZ_DAYS = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'];

    var now = new Date();
    var todayStr = now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0');

    var state = {
        year: now.getFullYear(),
        month: now.getMonth(), // 0-indexed
        selected: null,
        monthData: {}  // {'2026-03-04': {has_free, is_closed}}
    };

    function padZ(n) {
        return String(n).padStart(2, '0');
    }

    function toDateStr(year, month, day) {
        return year + '-' + padZ(month + 1) + '-' + padZ(day);
    }

    // ── Načtení dat z API ──────────────────────────────────────────────────
    function loadMonthData(year, month, cb) {
        $calendar.html('<div class="cal__loading">Načítám&hellip;</div>');
        $.ajax({
            url: '/?do=getMonthAvailability',
            data: { year: year, month: month + 1 },
            method: 'GET',
            dataType: 'json',
            success: function (res) {
                state.monthData = res.days || {};
                cb();
            },
            error: function () {
                // Při chybě API zobrazíme kalendář bez dat (všechny dny volné)
                state.monthData = {};
                cb();
            }
        });
    }

    function renderCalendar() {
        var firstDay = new Date(state.year, state.month, 1);
        var lastDay = new Date(state.year, state.month + 1, 0);
        var totalDays = lastDay.getDate();
        // Monday-first: JS getDay() 0=Sun → map to 0=Mon…6=Sun
        var startDow = (firstDay.getDay() + 6) % 7;
        var prevMonthLast = new Date(state.year, state.month, 0).getDate();

        var html = '';

        // ── Header ──────────────────────────────────────────────────────────
        html += '<div class="cal__header">';
        html += '<button class="cal__nav cal__nav--prev" aria-label="Předchozí měsíc">&#8249;</button>';
        html += '<span class="cal__title">' + CZ_MONTHS[state.month] + ' ' + state.year + '</span>';
        html += '<button class="cal__nav cal__nav--next" aria-label="Následující měsíc">&#8250;</button>';
        html += '</div>';

        // ── Grid ────────────────────────────────────────────────────────────
        html += '<div class="cal__grid" role="grid" aria-label="' + CZ_MONTHS[state.month] + ' ' + state.year + '">';

        // Day-name headers
        CZ_DAYS.forEach(function (d) {
            html += '<div class="cal__day-name" role="columnheader" aria-label="' + d + '">' + d + '</div>';
        });

        // Filler cells from previous month
        for (var i = 0; i < startDow; i++) {
            var pDay = prevMonthLast - startDow + i + 1;
            html += '<div class="cal__day cal__day--other-month" aria-hidden="true">' + pDay + '</div>';
        }

        // Days of the current month
        for (var d = 1; d <= totalDays; d++) {
            var date = new Date(state.year, state.month, d);
            var dow = (date.getDay() + 6) % 7;  // 0=Mon … 6=Sun
            var isWe = dow >= 5;
            var dateStr = toDateStr(state.year, state.month, d);
            var isPast = dateStr < todayStr;

            var dayInfo = state.monthData[dateStr] || null;
            var isToday = dateStr === todayStr;
            var isClosed = isWe || isPast || (dayInfo && dayInfo.is_closed) || (isToday && dayInfo && !dayInfo.has_free);
            var isFull = !isClosed && dayInfo && !dayInfo.has_free;
            var isSelected = state.selected &&
                state.selected.getDate() === d &&
                state.selected.getMonth() === state.month &&
                state.selected.getFullYear() === state.year;

            var label = d + '. ' + CZ_MONTHS[state.month] + ' ' + state.year;
            var cls = 'cal__day';

            if (isClosed) {
                cls += ' cal__day--closed';
                if (isToday) cls += ' cal__day--today';
                html += '<div class="' + cls + '" aria-hidden="true" role="gridcell">' + d + '</div>';
            } else if (isFull) {
                cls += ' cal__day--full';
                if (isToday) cls += ' cal__day--today';
                html += '<div class="' + cls + '" role="gridcell" aria-label="' + label + ' – obsazeno">' + d + '</div>';
            } else {
                cls += ' cal__day--available';
                if (isToday) cls += ' cal__day--today';
                if (isSelected) cls += ' cal__day--selected';
                html += '<button class="' + cls + '" data-date="' + dateStr + '" ' +
                    'aria-label="' + label + '" role="gridcell" tabindex="0">' + d + '</button>';
            }
        }

        // Filler cells for next month
        var remainder = (startDow + totalDays) % 7;
        if (remainder > 0) {
            for (var j = 1; j <= 7 - remainder; j++) {
                html += '<div class="cal__day cal__day--other-month" aria-hidden="true">' + j + '</div>';
            }
        }

        html += '</div>'; // .cal__grid

        $calendar.html(html);

        // ── Events ──────────────────────────────────────────────────────────
        $calendar.find('.cal__nav--prev').on('click', function () {
            state.month -= 1;
            if (state.month < 0) { state.month = 11; state.year -= 1; }
            loadMonthData(state.year, state.month, renderCalendar);
        });

        $calendar.find('.cal__nav--next').on('click', function () {
            state.month += 1;
            if (state.month > 11) { state.month = 0; state.year += 1; }
            loadMonthData(state.year, state.month, renderCalendar);
        });

        $calendar.find('.cal__day--available').on('click', function () {
            var ds = $(this).data('date');
            state.selected = new Date(ds + 'T00:00:00');
            renderCalendar();
            if (typeof window.app.openReservationModal === 'function') {
                window.app.openReservationModal(ds);
            }
        });
    }

    // Načíst aktuální měsíc a pak vykreslit
    loadMonthData(state.year, state.month, renderCalendar);
};

App.prototype.initReservationModal = function () {
    var self = this;
    var _onKeyDown = null;

    // ── Helpers ───────────────────────────────────────────────────────────────
    function formatDate(dateStr) {
        var p = dateStr.split('-');
        return parseInt(p[2], 10) + '.' + parseInt(p[1], 10) + '.' + p[0];
    }

    // Mapování JS service key → API type
    function toApiType(service) {
        return service === 'emise-stk' ? 'emise_stk' : 'stk';
    }

    function renderTimeSlots(apiSlots, selTime, dateStr) {
        var grid = document.getElementById('resTimeGrid');
        if (!grid) return;
        if (!apiSlots || !apiSlots.length) {
            grid.innerHTML = '<p class="res-no-slots">Pro tento den nejsou dostupné žádné termíny.</p>';
            return;
        }
        // Filtrování minulých slotů pro dnešní den
        var now = new Date();
        var nowDateStr = now.getFullYear() + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            String(now.getDate()).padStart(2, '0');
        var isToday = (dateStr === nowDateStr);
        var nowMinutes = now.getHours() * 60 + now.getMinutes();

        grid.innerHTML = apiSlots.map(function (slot) {
            var isSel = slot.time === selTime;
            var isFull = slot.is_full;
            if (!isFull && isToday) {
                var parts = slot.time.split(':');
                var slotMinutes = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
                if (slotMinutes < nowMinutes) { isFull = true; }
            }
            if (isFull) {
                return '<div class="time-slot time-slot--full" aria-disabled="true" title="Obsazeno">' + slot.time + '</div>';
            }
            return '<button type="button" class="time-slot' + (isSel ? ' time-slot--selected' : '') +
                '" data-time="' + slot.time + '" aria-pressed="' + isSel + '">' + slot.time + '</button>';
        }).join('');
    }

    function buildHTML(dateStr) {
        return '<div class="reservation-modal" id="reservationModal">' +
            '<div class="reservation-modal__overlay"></div>' +
            '<div class="reservation-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="resModalTitle">' +
            '<div class="reservation-modal__header">' +
            '<h3 id="resModalTitle">Rezervace termínu ' + formatDate(dateStr) + '</h3>' +
            '<button type="button" class="reservation-modal__close" aria-label="Zavřít">&times;</button>' +
            '</div>' +
            '<div class="reservation-modal__body" id="resModalBody">' +
            '<p class="reservation-modal__section-title">Zvolte typ prohlídky</p>' +
            '<div class="reservation-modal__service-grid">' +
            '<button type="button" class="service-type-btn" data-service="emise-stk" aria-pressed="false">Emise + STK</button>' +
            '<button type="button" class="service-type-btn" data-service="stk" aria-pressed="false">Pouze STK</button>' +
            '</div>' +
            '<p class="reservation-modal__description" id="resServiceNote" hidden></p>' +
            '<div class="reservation-modal__time-section" id="resTimeSection" hidden>' +
            '<p class="reservation-modal__section-title">Vyberte čas</p>' +
            '<div class="reservation-modal__time-grid" id="resTimeGrid">' +
            '<div class="cal__loading">Načítám termíny&hellip;</div>' +
            '</div>' +
            '</div>' +
            '<form class="reservation-modal__form" id="resForm" novalidate>' +
            '<p class="reservation-modal__section-title">Kontaktní údaje</p>' +
            '<div class="res-row">' +
            '<div class="res-field">' +
            '<label class="res-field__label" for="resFirstName">Jméno</label>' +
            '<input class="res-field__input" type="text" id="resFirstName" name="first_name" autocomplete="given-name">' +
            '<span class="res-field__error" id="resFirstNameErr"></span>' +
            '</div>' +
            '<div class="res-field">' +
            '<label class="res-field__label" for="resLastName">Příjmení *</label>' +
            '<input class="res-field__input" type="text" id="resLastName" name="last_name" autocomplete="family-name">' +
            '<span class="res-field__error" id="resLastNameErr"></span>' +
            '</div>' +
            '</div>' +
            '<div class="res-row">' +
            '<div class="res-field">' +
            '<label class="res-field__label" for="resPhone">Mobilní telefon *</label>' +
            '<input class="res-field__input" type="tel" id="resPhone" name="phone" autocomplete="tel">' +
            '<span class="res-field__error" id="resPhoneErr"></span>' +
            '</div>' +
            '<div class="res-field">' +
            '<label class="res-field__label" for="resEmail">E-mail</label>' +
            '<input class="res-field__input" type="email" id="resEmail" name="email" autocomplete="email">' +
            '<span class="res-field__error" id="resEmailErr"></span>' +
            '</div>' +
            '</div>' +
            '<div class="res-field">' +
            '<label class="res-field__label" for="resNote">Poznámka</label>' +
            '<textarea class="res-field__input res-field__input--textarea" id="resNote" name="note" rows="3" maxlength="1000"></textarea>' +
            '</div>' +
            '<div class="res-field res-field--checkbox">' +
            '<input type="checkbox" id="resConsent" name="consent">' +
            '<label class="res-field__label" for="resConsent">Souhlasím se zpracováním osobních údajů *</label>' +
            '</div>' +
            '<span class="res-field__error" id="resConsentErr"></span>' +
            '<p class="res-sms-note">Na zadané mobilní číslo vám po odeslání přijde SMS s potvrzovacím odkazem. Zkontrolujte prosím, zda je správně zadáno.</p>' +
            '<span class="res-field__error" id="resApiErr"></span>' +
            '<p class="res-required-note">* povinné položky</p>' +
            '<div class="reservation-modal__submit-row">' +
            '<button type="submit" class="res-submit-btn" id="resSubmitBtn" disabled>Rezervovat</button>' +
            '</div>' +
            '</form>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    // ── Validace ──────────────────────────────────────────────────────────────
    var RULES = {
        FirstName: {
            minLen: 0, pattern: null,
            msgs: { empty: '' }
        },
        LastName: {
            minLen: 1, pattern: null,
            msgs: { empty: 'Zadejte příjmení.' }
        },
        Phone: {
            minLen: 0, pattern: /^\+?(\d[\s\-]?){9,15}$/,
            msgs: { empty: 'Zadejte telefon.', invalid: 'Zadejte platné telefonní číslo.' }
        },
        Email: {
            minLen: 0, pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            msgs: { empty: '', invalid: 'Zadejte platnou e-mailovou adresu.' }
        }
    };

    function validateField(key) {
        var input = document.getElementById('res' + key);
        var errEl = document.getElementById('res' + key + 'Err');
        if (!input || !errEl) return true;
        var val = input.value.trim();
        var rule = RULES[key];
        var msg = '';
        if (!val) {
            msg = rule.msgs.empty || '';
        } else if (rule.pattern && !rule.pattern.test(val)) {
            msg = rule.msgs.invalid;
        }
        errEl.textContent = msg;
        input.classList.toggle('res-field__input--invalid', !!msg);
        return !msg;
    }

    function isFieldValid(key) {
        var input = document.getElementById('res' + key);
        if (!input) return false;
        var val = input.value.trim();
        var rule = RULES[key];
        if (!val && rule.minLen > 0) return false;
        if (val && rule.pattern && !rule.pattern.test(val)) return false;
        return true;
    }

    function updateSubmitState(selTime, selService) {
        var btn = document.getElementById('resSubmitBtn');
        if (!btn) return;
        var consent = document.getElementById('resConsent');
        btn.disabled = !(
            selService &&
            selTime &&
            isFieldValid('LastName') &&
            isFieldValid('Phone') &&
            isFieldValid('Email') &&
            consent && consent.checked
        );
    }

    // ── Open / close ──────────────────────────────────────────────────────────
    function openModal(dateStr) {
        closeModal();
        var selService = null;
        var selTime = null;
        var apiSlots = null;

        document.body.insertAdjacentHTML('beforeend', buildHTML(dateStr));
        document.body.style.overflow = 'hidden';

        var $modal = $('#reservationModal');

        function doClose() { closeModal(); }

        $modal.find('.reservation-modal__close').on('click', doClose);
        $modal.find('.reservation-modal__overlay').on('click', doClose);

        _onKeyDown = function (e) { if (e.key === 'Escape') doClose(); };
        document.addEventListener('keydown', _onKeyDown);

        // ── Načtení slotů z API ──────────────────────────────────────────────
        function loadSlots(service) {
            var grid = document.getElementById('resTimeGrid');
            if (grid) grid.innerHTML = '<div class="cal__loading">Načítám termíny&hellip;</div>';
            $.ajax({
                url: '/?do=getDaySlots',
                data: { date: dateStr, type: toApiType(service) },
                method: 'GET',
                dataType: 'json',
                success: function (res) {
                    apiSlots = res.slots || [];
                    renderTimeSlots(apiSlots, selTime, dateStr);
                },
                error: function () {
                    apiSlots = [];
                    if (grid) grid.innerHTML = '<p class="res-no-slots">Nepodařilo se načíst termíny.</p>';
                }
            });
        }

        // Service type selection
        $modal.on('click', '.service-type-btn', function () {
            selService = $(this).data('service');
            selTime = null;
            apiSlots = null;
            $modal.find('.service-type-btn').removeClass('service-type-btn--selected').attr('aria-pressed', 'false');
            $(this).addClass('service-type-btn--selected').attr('aria-pressed', 'true');

            var noteEl = document.getElementById('resServiceNote');
            if (noteEl) {
                if (selService === 'stk') {
                    noteEl.textContent = 'Pro vozidla se spalovacím motorem je nutné mít pro pravidelnou technickou prohlídku změřené emise.';
                    noteEl.removeAttribute('hidden');
                } else if (selService === 'emise-stk') {
                    noteEl.textContent = 'Před měřením emisí musí být vozidlo zahřáto na provozní teplotu.';
                    noteEl.removeAttribute('hidden');
                } else {
                    noteEl.setAttribute('hidden', '');
                }
            }

            var timeSection = document.getElementById('resTimeSection');
            if (timeSection) timeSection.removeAttribute('hidden');

            loadSlots(selService);

            $('#resModalTitle').text('Rezervace termínu ' + formatDate(dateStr));
            updateSubmitState(null, selService);

            // Scroll to time section
            var bodyEl = document.getElementById('resModalBody');
            if (timeSection && bodyEl) {
                setTimeout(function () {
                    var target = bodyEl.scrollTop + (timeSection.getBoundingClientRect().top - bodyEl.getBoundingClientRect().top) - 12;
                    bodyEl.scrollTo({ top: target, behavior: 'smooth' });
                }, 30);
            }
        });

        // Keyboard on service buttons
        $modal.on('keydown', '.service-type-btn', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); }
        });

        // Time slot selection
        $modal.on('click', '.time-slot:not(.time-slot--full)', function () {
            selTime = $(this).data('time');
            $modal.find('.time-slot').removeClass('time-slot--selected').attr('aria-pressed', 'false');
            $(this).addClass('time-slot--selected').attr('aria-pressed', 'true');
            $('#resModalTitle').text('Rezervace termínu ' + formatDate(dateStr) + ' ' + selTime);
            updateSubmitState(selTime, selService);

            // Smooth scroll to form + focus first field
            var form = document.getElementById('resForm');
            var bodyEl = document.getElementById('resModalBody');
            if (form && bodyEl) {
                var target = bodyEl.scrollTop + (form.getBoundingClientRect().top - bodyEl.getBoundingClientRect().top) - 12;
                setTimeout(function () {
                    bodyEl.scrollTo({ top: target, behavior: 'smooth' });
                    setTimeout(function () {
                        var f = document.getElementById('resFirstName');
                        if (f) f.focus();
                    }, 340);
                }, 30);
            }
        });

        // Keyboard on time slots
        $modal.on('keydown', '.time-slot:not(.time-slot--full)', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); }
        });

        // Blur + input validation
        ['FirstName', 'LastName', 'Phone', 'Email'].forEach(function (key) {
            $modal.find('#res' + key)
                .on('blur', function () { validateField(key); updateSubmitState(selTime, selService); })
                .on('input', function () { updateSubmitState(selTime, selService); });
        });

        $modal.find('#resConsent').on('change', function () { updateSubmitState(selTime, selService); });

        // ── Odeslání formuláře ───────────────────────────────────────────────
        $modal.find('#resForm').on('submit', function (e) {
            e.preventDefault();
            var ok = validateField('LastName') & validateField('Phone') & validateField('Email');
            var consentEl = document.getElementById('resConsent');
            var consentOk = consentEl && consentEl.checked;
            if (!consentOk) {
                var ce = document.getElementById('resConsentErr');
                if (ce) ce.textContent = 'Souhlas je povinný.';
            }
            if (!ok || !consentOk || !selTime) return;

            var apiErr = document.getElementById('resApiErr');
            if (apiErr) apiErr.textContent = '';

            var btn = document.getElementById('resSubmitBtn');
            if (btn) { btn.disabled = true; btn.textContent = 'Odesílám…'; }

            var payload = {
                type: toApiType(selService),
                date: dateStr,
                time_slot: selTime,
                first_name: document.getElementById('resFirstName').value.trim(),
                last_name: document.getElementById('resLastName').value.trim(),
                phone: document.getElementById('resPhone').value.trim(),
                email: document.getElementById('resEmail').value.trim(),
                note: document.getElementById('resNote').value.trim(),
                gdpr_consent: 1
            };

            $.ajax({
                url: '/?do=createReservation',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: function () {
                    showSuccess();
                },
                error: function (xhr) {
                    if (btn) { btn.disabled = false; btn.textContent = 'Rezervovat'; }
                    var msg = 'Nastala chyba. Zkuste to prosím znovu.';
                    try {
                        var resp = JSON.parse(xhr.responseText);
                        if (resp && resp.error) msg = resp.error;
                    } catch (ex) { }
                    if (apiErr) apiErr.textContent = msg;
                    // Při obsazení slotu znovu načíst dostupné termíny
                    if (xhr.status === 409 && selService) {
                        selTime = null;
                        updateSubmitState(null, selService);
                        loadSlots(selService);
                    }
                }
            });
        });

        // Initial focus
        var closeBtn = document.querySelector('.reservation-modal__close');
        if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
        var modal = document.getElementById('reservationModal');
        if (modal) modal.remove();
        document.body.style.overflow = '';
        if (_onKeyDown) {
            document.removeEventListener('keydown', _onKeyDown);
            _onKeyDown = null;
        }
    }

    function showSuccess() {
        var bodyEl = document.getElementById('resModalBody');
        if (!bodyEl) return;
        bodyEl.innerHTML =
            '<div class="reservation-modal__success">' +
            '<p class="success-title">Rezervace odeslána</p>' +
            '<p class="success-text">Děkujeme za vaši rezervaci. Na vaše telefonní číslo vám přijde SMS s odkazem pro potvrzení termínu. Kliknutím na odkaz v SMS rezervaci závazně potvrdíte.</p>' +
            '<button type="button" class="res-submit-btn js-close-success">Zavřít</button>' +
            '</div>';
        var cb = bodyEl.querySelector('.js-close-success');
        if (cb) { cb.addEventListener('click', closeModal); cb.focus(); }
    }

    // Expose for calendar click handler
    self.openReservationModal = openModal;
};

App.prototype.initWebStaff = function () {
    var self = this;
    // menu toggler
    $('.menu-toggler').off('click').on('click', function () {
        $(this).toggleClass("active");
        $(".menu-toggler .menu-icon").toggleClass("open");
        $(".menu").slideToggle();
    })

    // price sliders


    //  gallery
    // var lightbox = $('.gallery_slider a').simpleLightbox();
    $('.assembly_gallery__list a').simpleLightbox();

    // gallery uni page
    $('.gallery-slider a').simpleLightbox();
    $('.gallery-slider').not('.slick-initialized').slick({
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<span class="slider-arrow slider-arrow-left"></span>',
        nextArrow: '<span class="slider-arrow slider-arrow-right"></span>',
        responsive: [
            {
                breakpoint: 1705,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1220,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: false,
                }
            },
        ]
    });

    // $('.top_banner_slider').slick({
    //     // variableWidth: true,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     prevArrow: '<span class="slider_arrow slider_arrow--left"></span>',
    //     nextArrow: '<span class="slider_arrow slider_arrow--right"></span>',
    //     // responsive: [
    //     //     {
    //     //         breakpoint: 1705,
    //     //         settings: {
    //     //             slidesToShow: 3
    //     //         }
    //     //     },
    //     //     {
    //     //         breakpoint: 1220,
    //     //         settings: {
    //     //             slidesToShow: 2
    //     //         }
    //     //     },
    //     //     {
    //     //         breakpoint: 660,
    //     //         settings: {
    //     //             slidesToShow: 1,
    //     //             centerMode: true,
    //     //             variableWidth: false,
    //     //         }
    //     //     },
    //     // ]
    // });


};

App.prototype.reload = function () {
    // $(".collapse").show();
    // $(".collapse").hide();
    // $("[data-toggle='collapse']").off('click').on('click', function () {
    //     $header = $(this);
    //     $content = $($header.data('target'));
    //     $(".collapse").not($header.data('target')).hide();
    //     $content.slideToggle(500);
    // });
    //
    // if ($('#scrollHereBeforeAjax').length) {
    //     $("html, body").animate({scrollTop: $('#scrollHereBeforeAjax').offset().top}, 300);
    // }
};

